module.exports = __webpack_public_path__ + "img/people.961b3c55.svg";